/**
 * Created by ianva on 16/7/21.
 */

var React = require('react');
var CSSTransitionGroup = React.addons.CSSTransitionGroup;
var _ = require('underscore');



var T = React.PropTypes;

var PositionContainer = require('./position-container');

var NotifyItem  = require('./notify-item');

var {createUID} = require("./utils");



var _notices = [];

var createRefID = function(){
    return createUID('gin-notify-ref-id');
};

var GinNotify = React.createClass({

    displayName: 'GinNotify',

    propTypes: {
        message : T.oneOfType([ T.array, T.string, T.number ])
    },
    getDefaultProps(){
        return {
            notices: []
        }
    },
    getInitialState(){

        var notice = this.props.message;

        if(! notice){
            return {
                notices: _notices
            }
        }

        var notices = _.isArray(notice)?  notice : [ notice ];

        _notices = _notices.concat(_.map( notices,(notice)=>{
            return {
                refID : createRefID(),
                content: notice
            }
        }));

        return {
            notices: _notices
        }

    },
    componentWillReceiveProps(nextProps) {
        this.add(nextProps.message);
    },
    add( text ){

        _notices.push({
            refID: createRefID(),
            content: text
        });

        this.setState({
            notices: _notices
        });

    },
    remove(refID){

        _notices = _.filter(this.state.notices,(item)=>{
            return item.refID !== refID
        });

        this.setState({
            notices:_notices
        });


    },
    render(){

        var { notices } = this.state;

        return (
            <PositionContainer>
                <CSSTransitionGroup transitionName="ani-gin-notify" transitionEnterTimeout={700} transitionLeaveTimeout={1000}>
                {
                    _.map(notices,(item,index)=>{

                        return (
                            <NotifyItem {...this.props}
                                        key={item.refID}
                                        refID={ item.refID }
                                        content={ item.content }
                                        onClose={ ()=>{this.remove( item.refID )} } >
                            </NotifyItem>
                        )
                    })
                }
                </CSSTransitionGroup>
            </PositionContainer>
        )
    }
});

module.exports = GinNotify;



/** WEBPACK FOOTER **
 ** ./script/cutil/gin-notify/notify.jsx
 **/